import { render, staticRenderFns } from "./copyRights.vue?vue&type=template&id=f8cc2fbc&scoped=true&"
import script from "./copyRights.vue?vue&type=script&lang=js&"
export * from "./copyRights.vue?vue&type=script&lang=js&"
import style0 from "./copyRights.vue?vue&type=style&index=0&id=f8cc2fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cc2fbc",
  null
  
)

export default component.exports